import React from 'react';
import { Loader2 } from 'lucide-react';

/**
 * Skeleton loader for cards
 */
export function CardSkeleton({ count = 1 }) {
  return (
    <>
      {Array.from({ length: count }).map((_, i) => (
        <div
          key={i}
          className="bg-white rounded-xl shadow-md border border-gray-200 overflow-hidden animate-pulse"
        >
          <div className="h-48 bg-gray-200" />
          <div className="p-6 space-y-4">
            <div className="h-4 bg-gray-200 rounded w-3/4" />
            <div className="h-4 bg-gray-200 rounded w-1/2" />
            <div className="h-10 bg-gray-200 rounded w-1/3" />
          </div>
        </div>
      ))}
    </>
  );
}

/**
 * Skeleton loader for tables
 */
export function TableSkeleton({ rows = 5, columns = 4 }) {
  return (
    <div className="bg-white rounded-xl shadow-md border border-gray-200 overflow-hidden">
      <div className="p-6 border-b border-gray-200">
        <div className="h-6 bg-gray-200 rounded w-1/4 animate-pulse" />
      </div>
      <div className="divide-y divide-gray-200">
        {Array.from({ length: rows }).map((_, i) => (
          <div key={i} className="p-6 grid gap-4 animate-pulse" style={{ gridTemplateColumns: `repeat(${columns}, 1fr)` }}>
            {Array.from({ length: columns }).map((_, j) => (
              <div key={j} className="h-4 bg-gray-200 rounded" />
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}

/**
 * Skeleton loader for forms
 */
export function FormSkeleton() {
  return (
    <div className="bg-white rounded-xl shadow-md border border-gray-200 p-6 space-y-6 animate-pulse">
      <div className="space-y-2">
        <div className="h-4 bg-gray-200 rounded w-1/4" />
        <div className="h-10 bg-gray-200 rounded" />
      </div>
      <div className="space-y-2">
        <div className="h-4 bg-gray-200 rounded w-1/4" />
        <div className="h-24 bg-gray-200 rounded" />
      </div>
      <div className="h-10 bg-gray-200 rounded w-1/3" />
    </div>
  );
}

/**
 * Inline loading spinner
 */
export function LoadingSpinner({ size = 24, className = '' }) {
  return (
    <Loader2
      className={`animate-spin text-[#c5a059] ${className}`}
      size={size}
      aria-label="Loading"
    />
  );
}

/**
 * Full page loading state
 */
export function FullPageLoader({ message = 'Loading...' }) {
  return (
    <div className="min-h-screen bg-[#fdfbf7] flex items-center justify-center p-6">
      <div className="text-center">
        <LoadingSpinner size={48} className="mx-auto mb-4" />
        <p className="text-gray-600 animate-pulse">{message}</p>
      </div>
    </div>
  );
}

/**
 * Button loading state
 */
export function ButtonLoader({ children, loading, ...props }) {
  return (
    <button {...props} disabled={loading || props.disabled}>
      {loading ? (
        <span className="flex items-center justify-center gap-2">
          <LoadingSpinner size={18} />
          <span>Loading...</span>
        </span>
      ) : (
        children
      )}
    </button>
  );
}

/**
 * Shimmer effect for loading states
 */
export function Shimmer({ className = '' }) {
  return (
    <div className={`skeleton ${className}`} />
  );
}



